import axios from 'axios';
import config from './config';

export const getStbSubInfo = async (token) => {
    const body = {
        token: encodeURIComponent(token),
        callerId: 'NOWWEB',
        callerReferenceNo: new Date().getTime().toString()
    };

    const response = await axios.post(`${config.MyAccountURL}stbPartner/getStbSubInfo`, body, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    console.log('getStbSubInfo body', body);
    console.log('getStbSubInfo response', response.data);
    return response.data;
};

export const getStbActivationURL = async (token) => {
    const body = {
        token: encodeURIComponent(token),
        callerId: 'NOWWEB',
        callerReferenceNo: new Date().getTime().toString()
    };

    const response = await axios.post(`${config.MyAccountURL}stbPartner/getStbActivationURL`, body, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    console.log('getStbActivationURL body', body);
    console.log('getStbActivationURL response', response.data);
    return response.data;
};
